import React, { FC } from 'react';
import { Box, Grid } from '@mui/material';
import styles from './styles';
import genericClasses from '../../../theme/GenericClasses';
import CustomButton from '../CustomButton';

interface ILongTermModalLayout {
  children: React.ReactNode;
  primary: {
    label: string;
    onPress: () => void;
    disabled?: boolean;
  };
  secondary?: {
    label: string;
    onPress: () => void;
    disabled?: boolean;
  };
}

const LongTermModalLayout: FC<ILongTermModalLayout> = ({
  secondary,
  children,
  primary,
}) =>
  (
    <Box sx={styles.container}>
      <Box sx={styles.subContainer}>
        <Grid container columnSpacing="30px">
          {children}
        </Grid>
      </Box>
      <Box sx={[styles.buttonContainer, genericClasses.flex]}>
        {secondary && (
        <CustomButton
          disabled={secondary?.disabled}
          customButtonStyle={styles.secondaryButton}
          label={secondary?.label}
          onClick={secondary?.onPress}
        />
        )}
        <CustomButton
          disabled={primary?.disabled}
          label={primary.label}
          customButtonStyle={styles.closeButton}
          onClick={primary.onPress}
        />
      </Box>
    </Box>
  );

export default LongTermModalLayout;
